import axios from "axios";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { BASE_PATH, HeadersInfo } from "../../../api/api";
import { userInfoProps } from "../../../atoms/atom";

// 게시글 쓰기
interface IPostProps {
  service_code: string | undefined;
  title: string | undefined;
  postValue: any;
  userInfo: userInfoProps;
}

const postData = async (props: IPostProps) => {
  const { service_code, title, postValue, userInfo } = props;
  let api = await axios.post(
    `${BASE_PATH}/vfunlounge/posts/${service_code}/${title}`,
    postValue,
    HeadersInfo(userInfo.Ssoinfo, userInfo.Userid, userInfo.Userbirth, userInfo.channelingType, "multipart/form-data")
  );

  return api;
};

export const usePostContentsMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(postData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries(["page_board_list"]);
        alert(t("Post_writing_is_complete"));
        window.scrollTo(0, 0);
      } else {
        alert(t(api?.data.msg));
      }
    },
    onError: (error) => {
      // console.log(error, "Post Mutation error");
    }
  });
};

// 이전  내용 보기
interface getBeforeProps {
  userInfo: userInfoProps;
  service_code: string | undefined;
  title: string | undefined;
  editContentNum: number;
}

export const getBeforeContent = async (props: getBeforeProps) => {
  const { service_code, title, editContentNum, userInfo } = props;
  const { data } = await axios.get(
    `${BASE_PATH}/vfunlounge/posts/${service_code}/${title === undefined ? "all" : title}/${editContentNum}`,
    HeadersInfo(userInfo.Ssoinfo, userInfo.Userid, userInfo.Userbirth, userInfo.channelingType, "application/json")
  );
  return data;
};

// 수정 내용 저장하기
interface IPutProps {
  postValue: any;
  userInfo: userInfoProps;
  service_code: string | undefined;
  title: string | undefined;
  editContentNum: number;
}

const putData = async (props: IPutProps) => {
  const { service_code, title, editContentNum, userInfo, postValue } = props;
  const api = await axios.post(
    `${BASE_PATH}/vfunlounge/posts/${service_code}/${title === undefined ? "all" : title}/${editContentNum}`,
    postValue,
    HeadersInfo(userInfo.Ssoinfo, userInfo.Userid, userInfo.Userbirth, userInfo.channelingType, "multipart/form-data")
  );

  return api;
};

export const usePutContentsMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(putData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries(["page_board_list"]);
        alert(t("The_post_has_been_edited"));
      } else {
        alert(t(api?.data.msg));
      }
    },
    onError: (error) => {
      // console.log(error, "Put Mutation error");
    }
  });
};
